import './main.css';
import './global/global';
import Layout from 'utils/layout';
import Video from 'utils/video';
import Tracking from 'utils/tracking';
/* eslint-disable no-unused-vars */
import Swiper, {
  Navigation,
  Pagination,
  Keyboard,
  EffectFade,
  Controller,
  Scrollbar,
  Autoplay,
  A11y,
  Mousewheel,
} from 'swiper';
/* eslint-enable no-unused-vars */

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections].map((section) => section.dataset.section).filter(uniq);
  const layout = Layout.getInstance();
  const moduleList = {};

  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const { sectionId } = e.detail;
      const el = e.target.querySelector('[data-section]');
      (moduleList[sectionId]
        ? Promise.resolve(moduleList[sectionId].m)
        : import(/* webpackChunkName: "[index]" */ `./${el.dataset.section}/index.js`)
      ).then((m) => {
        const dataEl = el.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = el.querySelectorAll('[data-component="video"]');
        const videos = videoEls && [...videoEls].map((videoEl) => new Video({ el, video: videoEl, layout }));
        m?.default(el, { ...data, layout, videos });
      });
    });
  }

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        if (typeof module !== 'function') {
          return;
        }
        const modules = [...sections].filter((section) => section.dataset.section === name);
        modules.forEach((element) => {
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos = videoEls && [...videoEls].map((videoEl) => new Video({ element, video: videoEl, layout }));
          module(element, { ...data, layout, videos });
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log(`Error loading module ${name}:`, error);
        }
      });
  });

  // Added this section to ensure Swiper is properly initialized
  Swiper.use([Navigation, Pagination, Keyboard, EffectFade, Controller, Scrollbar, Autoplay, A11y, Mousewheel]);
  window.Swiper = Swiper;

  Tracking();
})();
